module.exports = __webpack_public_path__ + "media/leather_4.e62dc275.mp3";